import React from "react";

const Select = ({ label, isRequired, placeholder = "Select", value, onChange = () => {}, options = [] }) => {
  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}
          {isRequired ? <span className="required_star">*</span> : ""}
        </label>
      )}
      <select className="input_select" onChange={(e) => onChange(e.target.value)}>
        <option selected={!value} value="">
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option selected={value === (option.label || option.value || option)} key={index} value={option.value || option}>
            {option.label || option}
          </option>
        ))}
      </select>
    </>
  );
};

export default Select;
